import { render } from "./PostIndexCollection.vue?vue&type=template&id=75488e40"
import script from "./PostIndexCollection.vue?vue&type=script&lang=js"
export * from "./PostIndexCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__